import ReqClient from './request.class'

// 获取代理商信息
export async function getAgentInfo(params) {
  const Req = new ReqClient({
    url: '/api/ptom/agent/querylistpagination',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 添加代理商配置
export async function addAgentInfo(params) {
  const Req = new ReqClient({
    url: '/api/ptom/agent/add',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 编辑开发者配置
export async function updateAgentInfo(params) {
  const Req = new ReqClient({
    url: '/api/ptom/agent/save',
    method: 'POST',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 代投账号管理查询
export async function getProxyAccountList(data) {
  const Req = new ReqClient({
    url: '/api/ptom/proxy-account/getProxyAccountData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 代投账号管理编辑
export async function updateProxyAccount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/proxy-account/editProxyAccount',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 代投账号管理新增
export async function addProxyAccount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/proxy-account/addProxyAccount',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 代投账号状态启用禁用
export async function changeProxyAccountStatus(params) {
  const Req = new ReqClient({
    url: '/api/ptom/proxy-account/changeStatus',
    method: 'GET',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
